
        import * as module0 from './controllers/factur_x_validator_controller.js';import * as module1 from './controllers/navigation_controller.js';import * as module2 from './controllers/webmcp_controller.js'
        const modules = {
            "./controllers/factur_x_validator_controller.js": module0,
            "./controllers/navigation_controller.js": module1,
            "./controllers/webmcp_controller.js": module2,
        };
        export default modules;
      